import { ensureLeadingSlash } from '@/lib/utils/link-utils'

const ANONYMOUS_TRACKING_VALUE = 'anonyme'

export type ProductQrCodeUrlParams = {
  siteOrigin: string
  urlKey: string | null | undefined
  reference: string
  subsidiaryId?: string
  companyCode?: string
}

export function buildProductQrCodeUrl({
  siteOrigin,
  urlKey,
  reference,
  subsidiaryId,
  companyCode,
}: ProductQrCodeUrlParams): string {
  if (!urlKey) {
    return reference
  }

  try {
    const url = new URL(ensureLeadingSlash(urlKey), siteOrigin)

    url.searchParams.set('utm_source', 'qrcode')
    url.searchParams.set('utm_medium', 'etiquette')
    url.searchParams.set(
      'utm_content',
      `${subsidiaryId || ANONYMOUS_TRACKING_VALUE}_${companyCode || ANONYMOUS_TRACKING_VALUE}_${reference}`,
    )

    return url.toString()
  } catch (err) {
    console.error('buildProductQrCodeUrl failed', { siteOrigin, urlKey, reference }, err)

    return reference
  }
}
